import React from 'react';
import { Filter } from 'lucide-react';
interface SearchFiltersProps {
  filters: {
    budgetMin: string;
    budgetMax: string;
    locationType: string[];
    plotSize: string;
    legalStatus: string[];
  };
  setFilters: React.Dispatch<React.SetStateAction<{
    budgetMin: string;
    budgetMax: string;
    locationType: string[];
    plotSize: string;
    legalStatus: string[];
  }>>;
  onReset?: () => void;
}
export function SearchFilters({
  filters,
  setFilters,
  onReset
}: SearchFiltersProps) {
  const handleReset = () => {
    if (onReset) {
      onReset();
    } else {
      setFilters({
        budgetMin: '',
        budgetMax: '',
        locationType: [],
        plotSize: '',
        legalStatus: []
      });
    }
  };
  const handleLocationTypeChange = (type: string) => {
    setFilters(prev => ({
      ...prev,
      locationType: prev.locationType.includes(type) ? prev.locationType.filter(t => t !== type) : [...prev.locationType, type]
    }));
  };
  const handleLegalStatusChange = (status: string) => {
    setFilters(prev => ({
      ...prev,
      legalStatus: prev.legalStatus.includes(status) ? prev.legalStatus.filter(s => s !== status) : [...prev.legalStatus, status]
    }));
  };
  return <div data-testid="search-filters" className="bg-white border border-gray-300 p-6 h-full" data-id="element-1080">
      <div className="flex items-center justify-between mb-6 pb-4 border-b border-gray-200" data-id="element-1081">
        <h2 data-testid="search-filters-title" className="font-bold text-lg flex items-center gap-2" data-id="element-1082">
          <Filter className="w-5 h-5" data-id="element-1083" /> Filters
        </h2>
        <button data-testid="search-filters-reset-btn" onClick={handleReset} className="text-sm text-gray-500 hover:text-gray-900 underline" data-id="element-1084">
          Reset
        </button>
      </div>

      <div className="space-y-8" data-id="element-1085">
        <div data-testid="search-filters-budget-section" className="space-y-3" data-id="element-1086">
          <h3 className="font-mono text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-1087">
            Budget (Lakhs)
          </h3>
          <div className="flex items-center gap-2" data-id="element-1088">
            <input data-testid="search-filters-budget-min-input" type="number" placeholder="Min" value={filters.budgetMin} onChange={e => setFilters(prev => ({
            ...prev,
            budgetMin: e.target.value
          }))} className="w-full p-2 border border-gray-300 bg-gray-50 font-mono text-sm focus:outline-none focus:border-gray-500" data-id="element-1089" />
            <span className="text-gray-400" data-id="element-1090">-</span>
            <input data-testid="search-filters-budget-max-input" type="number" placeholder="Max" value={filters.budgetMax} onChange={e => setFilters(prev => ({
            ...prev,
            budgetMax: e.target.value
          }))} className="w-full p-2 border border-gray-300 bg-gray-50 font-mono text-sm focus:outline-none focus:border-gray-500" data-id="element-1091" />
          </div>
        </div>

        <div data-testid="search-filters-location-section" className="space-y-3" data-id="element-1092">
          <h3 className="font-mono text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-1093">
            Location Type
          </h3>
          <div className="space-y-2" data-id="element-1094">
            {['Urban / City Limits', 'Peri-urban', 'Rural / Agricultural'].map(type => <label key={type} className="flex items-center gap-3 cursor-pointer" data-id="element-1095">
                  <input data-testid={`search-filters-location-${type.toLowerCase().replace(/\s+/g, '-')}-checkbox`} type="checkbox" checked={filters.locationType.includes(type)} onChange={() => handleLocationTypeChange(type)} className="w-4 h-4 border-gray-300 rounded text-gray-800 focus:ring-gray-500" data-id="element-1096" />
                  <span className="text-sm text-gray-700" data-id="element-1097">{type}</span>
                </label>)}
          </div>
        </div>

        <div data-testid="search-filters-size-section" className="space-y-3" data-id="element-1098">
          <h3 className="font-mono text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-1099">
            Plot Size (Sq. Ft)
          </h3>
          <div className="space-y-2" data-id="element-1100">
            {['Under 1,000', '1,000 - 2,000', '2,000 - 5,000', '5,000+'].map(size => <label key={size} className="flex items-center gap-3 cursor-pointer" data-id="element-1101">
                  <input data-testid={`search-filters-size-${size.toLowerCase().replace(/\s+/g, '-')}-radio`} type="radio" name="plot-size" checked={filters.plotSize === size} onChange={() => setFilters(prev => ({
              ...prev,
              plotSize: size
            }))} className="w-4 h-4 border-gray-300 text-gray-800 focus:ring-gray-500" data-id="element-1102" />
                  <span className="text-sm text-gray-700" data-id="element-1103">{size}</span>
                </label>)}
          </div>
        </div>

        <div data-testid="search-filters-legal-section" className="space-y-3" data-id="element-1104">
          <h3 className="font-mono text-sm font-bold text-gray-500 uppercase tracking-wider" data-id="element-1105">
            Legal Status
          </h3>
          <div className="space-y-2" data-id="element-1106">
            {['NA Converted', 'RERA Registered', 'Collector Approved', 'Gram Panchayat'].map(status => <label key={status} className="flex items-center gap-3 cursor-pointer" data-id="element-1107">
                <input data-testid={`search-filters-legal-${status.toLowerCase().replace(/\s+/g, '-')}-checkbox`} type="checkbox" checked={filters.legalStatus.includes(status)} onChange={() => handleLegalStatusChange(status)} className="w-4 h-4 border-gray-300 rounded text-gray-800 focus:ring-gray-500" data-id="element-1108" />
                <span className="text-sm text-gray-700" data-id="element-1109">{status}</span>
              </label>)}
          </div>
        </div>
      </div>
    </div>;
}